import { createContext, useContext, useState } from 'react';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';

const FilterContext = createContext(null);


const FilterProvider = ({children}) => {

    const setDefaultValues = {
        date_from: dayjs().set('hour', 0).set('minute',0).set('second',0), // .subtract(1, 'day'),
        date_to: dayjs().set('hour', 23).set('minute',59).set('second',59),
        email: '',
        name: '',
        orderNumber: '',
        country: '',
        sources :['ebay', 'amazon', 'site_en', 'site_ru', 'wb', 'ozon', 'yandex', 'megamarket', 'other']
    }
    
    const [stateSearchData, setStateSearchData] = useState(setDefaultValues)
    const updateDefaultStateSearchData = () => setStateSearchData({...setDefaultValues})


    const updateStateSearchData = (e, type) => {

        if (type === 'checkbox'){
            if (e.target.checked){
                setStateSearchData({...stateSearchData, sources:[...stateSearchData.sources, e.target.id]})
            } else {
                setStateSearchData({...stateSearchData, sources:[...stateSearchData.sources.filter(existingID => existingID !== e.target.id)]})
            }
        } else if (type === 'date_from') {
            setStateSearchData({ ...stateSearchData, ['date_from']:e })
        } else if (type === 'date_to') {
            setStateSearchData({ ...stateSearchData, ['date_to']:e })
        } else {
            setStateSearchData({ ...stateSearchData, [e.target.name]:e.target.value })
        }
    }

    const value = {stateSearchData, updateStateSearchData, updateDefaultStateSearchData };

    return <FilterContext.Provider value={value}>
        {children}
    </FilterContext.Provider>
}


const useFilter = ()=> {
    return useContext(FilterContext);
}


export { useFilter, FilterProvider};